<template>
<div class="kpi-container">

    <h2 class="globalHeader">Meine Lohnabrechnung {{month.formatKapitelMonth(payrollMonth)}}</h2>
<!--    <h2 class="globalHeaderWithSubHeader">Meine Lohnabrechnung {{month.formatKapitelMonth(payrollMonth)}}</h2>-->
<!--    <h4 class="globalHeaderWithSubHeader">Personalaufwendungen im Detail</h4>-->
    <MonthKpiPayroll v-model="payrollMonth"/>

    <h2 class="globalHeader">Mein Umsatz im {{month.formatKapitelMonth(revenueMonth)}}</h2>
<!--    <h2 class="globalHeaderWithSubHeader">Mein Umsatz im {{month.formatKapitelMonth(revenueMonth)}}</h2>-->
<!--    <h4 class="globalHeaderWithSubHeader">Produktivzeiten im Detail</h4>-->
    <MonthKpiRevenue v-model="revenueMonth"/>

    <h2 class="globalHeaderWithSubHeader">Mein Beitrag</h2>
    <h4 class="globalHeaderWithSubHeader"><!--zum Umsatz & -->zum Jahresüberschuss</h4>
    <MonthKpiRevenueAndExcessContribution :selectedMonth="selectedMonth"/>

    <h2 class="globalHeaderWithSubHeader">Jahresüberschuss</h2>
    <h4 class="globalHeaderWithSubHeader">aller Fachkräfte bei <b style="color:var(--ion-color-superblack-tint)">ines</b></h4>
    <MonthKpiCompany :selectedMonth="selectedMonth"/>

</div>
</template>

<script setup lang="ts">
import {PropType, ref} from 'vue';

import {kapitelMonthString} from '@/graphql/kapitelTypes';
import MonthKpiRevenueAndExcessContribution
    from "@/views/components/MonthKPI/section/MonthKPIRevenueAndExcessContribution.vue";
import MonthKpiCompany from "@/views/components/MonthKPI/section/MonthKPICompany.vue";
import MonthKpiPayroll from "@/views/components/MonthKPI/section/MonthKPIPayroll.vue";
import MonthKpiRevenue from "@/views/components/MonthKPI/section/MonthKPIRevenue.vue";
import month from "@/helper/datetime/month";
import MonthKPIPlanningSummary from "@/views/components/MonthKPI/section/MonthKPIPlanningSummary.vue";

const props = defineProps({
    selectedMonth: {
        type: String as PropType<kapitelMonthString>,
        required: true,
    }
});

const payrollMonth = ref(props.selectedMonth);
const revenueMonth = ref(props.selectedMonth);
</script>

<style lang="scss" scoped>
.kpi-container {
    display: flex;
    flex-direction: column;
}
</style>
